module.exports = __webpack_public_path__ + "img/Nordstrom_case_study_2.6f8dbe9a.jpg";